export const USER_AUTH_REQUEST_START: string = 'user/auth/REQUEST_START';
export const USER_AUTH_REQUEST_FAIL: string = 'user/auth/REQUEST_FAIL';
export const USER_AUTH_REQUEST_SUCCESS: string = 'user/auth/REQUEST_SUCCESS';
export const USER_AFFILIATE_DETAILS_REQUEST_START: string = 'user/affiliateDetails/REQUEST_START';
export const USER_AFFILIATE_DETAILS_REQUEST_FAIL: string = 'user/affiliateDetails/REQUEST_FAIL';
export const USER_AFFILIATE_DETAILS_REQUEST_SUCCESS: string = 'user/affiliateDetails/REQUEST_SUCCESS';
export const UPDATE_USER_AFFILIATE_DETAILS_REQUEST_START: string = 'user/update/affiliateDetails/REQUEST_START';
export const UPDATE_USER_AFFILIATE_DETAILS_REQUEST_FAIL: string = 'user/update/affiliateDetails/REQUEST_FAIL';
export const UPDATE_USER_AFFILIATE_DETAILS_REQUEST_SUCCESS: string = 'user/update/affiliateDetails/REQUEST_SUCCESS';
export const UPDATE_SETTINGS_STATUS_TO_INITIAL: string = 'user/update/affiliateDetails/SET_INITIAL';

export const SET_USER_AUTH_STATE: string = 'user/auth/SET_STATE';
export const SET_USER_AUTH_DETAIL_STATE: string = 'user/auth/detail/SET_STATE';
export const SET_USER_INITIAL_AUTH_DETAIL_STATE: string = 'user/auth/detail/SET_INITIAL_STATE';
export const RESET_REDUX_STORE_TO_INITIAL_STATE: string = 'session/SET_INITIAL_STATE'
export const API_REQUEST_FAIL_ERROR: string = 'api/request/FAIL_ERROR';
export const UPDATE_LAUNCH_DARKLY_FLAG_CONFIG: string = 'user/update/affiliateDetails/FLAGS_CONFIG';

export const SET_KEYCLOAK_USER_DETAILS: string = 'user/auth/SET_KEYCLOAK_DETAILS';

export const SET_LOGIN_API_ERROR: string = 'user/auth/SET_LOGIN_API_ERROR';

export const SET_SUPER_USER_STATE: string = 'user/auth/SET_SUPER_USER_STATE';